import React from 'react'
import { Button, Group, Modal, Text } from '@mantine/core'

export default function ConfirmModal({ opened, onClose, onConfirm, title, message, loading }) {
  return (
    <Modal opened={opened} onClose={onClose} title={title || 'Подтверждение'} size="sm" centered>
      <Text size="sm" mb="xl">
        {message}
      </Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={onClose} disabled={loading}>
          Отмена
        </Button>
        <Button color="red" onClick={onConfirm} loading={loading}>
          Удалить
        </Button>
      </Group>
    </Modal>
  )
}
